export default __webpack_public_path__ + "f9eb56131ff9b85873f817ef311f7a1f.svg";